import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
// import * as Models from 'appshared/models/shared';
import { RoleGuard } from 'client/app/guards/role.guard';

import { TrafficCalcComponent } from './traffic-calc/traffic-calc.component';

const routes: Routes = [
	{
		path: 'traffic-calc',
		component: TrafficCalcComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.staffUserRole },
		resolve: []
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class CalculatorsRoutingModule { }
